<template>
  <div class="order-create">
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card>
              <template #header>
                <div class="pull-left mt-2 mb-2"><strong>Order {{item.location.name}} - {{(item.delivery_date)}} (# {{item.id}})</strong></div>
              </template>
              <b-row>
                <b-col cols="12" md="4">
                  <b-row>
                    <b-col>
                      <h5>Basisgegevens</h5>
                      <hr>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <p>
                        <strong>Geplaatst op</strong><br>
                        {{item.created_at | prettyDate}}
                      </p>
                      <p>
                        <strong>Transportdatum</strong><br>
                        {{item.delivery_date}}
                      </p>
                      <p>
                        <strong>Locatie</strong><br>
                        Locatiecode {{item.location.code}}<br>
                        <span v-if="item.location.internal_reference !== null">Klantreferentie {{item.location.internal_reference}}<br></span>
                      </p>
                      <p>
                        <strong>Adres</strong><br>
                        {{item.location.name}}<br>
                        {{item.location.address}}<br>
                        {{item.location.postal_code}} {{item.location.city}}
                      </p>
                      <p>
                        <strong>In opdracht van</strong><br>
                        <span v-if="item.user">{{item.user.name}}</span>
                        <span v-else>-</span>
                      </p>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="12" md="8">
                  <b-row>
                    <b-col>
                      <h5>Orderrows</h5>
                      <hr>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <table class="table table-sm table-order">
                        <thead>
                        <tr>
                          <th>Product</th>
                          <th>Beschrijving</th>
                          <th>Groep</th>
                          <th class="text-right">Aantal</th>
                          <th class="text-right">Prijs</th>
                        </tr>
                        </thead>
                        <tbody v-for="orderRow in item.order_rows">
                        <tr class="table-info">
                          <td colspan="5">
                            <span v-if="orderRow.transport === 'pickup'">
                              Ophalen {{orderRow.type}}
                              <span v-if="orderRow.type === 'sealbags'"> - sealbag nummer: {{orderRow.sealbag_number}}</span>
                            </span>
                            <span v-if="orderRow.transport === 'delivery'">Leveren</span>
                          </td>
                        </tr>
                        <tr v-for="product in orderRow.products">
                          <td>{{product.full_description}}</td>
                          <td>{{product.description}}</td>
                          <td>{{product.subgroup | prettyGroup}}</td>
                          <td class="text-right">{{product.quantity}}</td>
                          <td class="text-right">€ {{product.total | currency}}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                          <tr class="table-active">
                            <td colspan="3">Totalen</td>
                            <td class="text-right">{{item.total_quantity}}</td>
                            <td class="text-right">€ {{item.total_price | currency}}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
    import {getData} from '../../api';
    import moment from 'moment';

    export default {
        name: 'order',
        props: ['id'],
        data () {
            return {
                saveButtonDisabled: false,
                feedback: {
                    show: false,
                    text: '',
                    variant: null,
                    dismissCountDown: 4
                },
                editable: false,
                companyOptions: [],
                countryOptions: [],
                item: {},
                errors: null,
            }
        },
        methods: {
            async getItem() {
                const item = await getData('orders/'+this.$route.params.id).then(response => response.data);
                this.item = item.data;
            },
        },
        computed: {
            totalPrepend() {
                if(this.item.type === 'Sealbag bestellen') {
                    return 'Totaal'
                } else {
                    return 'Waarde'
                }
            },
            total() {
                let total = 0;
                for (let i = 0; i < this.item.products.length; i++) {
                    total += this.item.products[i]['price']*this.item.products[i]['quantity'];
                }
                return total;
            },
            qtt() {
                let qtt = 0;
                for (let i = 0; i < this.item.products.length; i++) {
                    qtt += parseInt(this.item.products[i]['quantity'])
                }
                return qtt;
            },
        },
        filters: {
           currency(value) {
            return new Intl.NumberFormat('nl', {
              style: 'decimal',
              minimumFractionDigits: 2,
            }).format(value)
           },
           prettyDate(value) {
            return moment(value).format('DD-MM-YYYY, HH:mm');
           },
           prettyGroup(value) {
            let group = '';

              switch(value) {
                case 'notes':
                group = 'Biljetten';
                break;

                case 'coins':
                group = 'Munten';
                break;

                case 'foil-bags':
                group = 'Foliepakken';
                break;

                case 'coin-bags':
                group = 'Muntzakken';
                break;

                case 'coin-rolls':
                group = 'Muntrollen';
                break;

                case 'stamps':
                group = 'Koopzegels';
                break;
              }

              return group;
           }
        },
        beforeMount() {
            this.getItem();
        },
    }
</script>

<style>
  .order-create .input-group-prepend {
    width: 40%;
  }
  .order-create .input-group-text {
    width: 100%;
  }
  .order-create .input-group-append {
    width: 20%;
  }
</style>
